import { render } from "./AppTimerPage.vue?vue&type=template&id=254e4b75"
import script from "./AppTimerPage.vue?vue&type=script&lang=js"
export * from "./AppTimerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__